export default __webpack_public_path__ + "static/media/product-3.19daec50.jpg";